'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { SessionTimeout } from './SessionTimeout';
import { useKioskMode } from '@/hooks/useKioskMode';

interface KioskSessionManagerTimeoutProps {
  company: string;
}

export const KioskSessionManager = ({
  company,
}: KioskSessionManagerTimeoutProps) => {
  const pathname = usePathname();
  const { isEnabled, isVisitor, inactivityPeriod } = useKioskMode();

  const pathParts = pathname.split('/');
  const companyIndex = pathParts.findIndex((part) => part === company);
  const guestBookSlug = pathParts[companyIndex + 1];

  const isKioskPage = pathname?.endsWith(`/${guestBookSlug}/kiosk`);

  console.log(
    `KioskSessionManager: isEnabled=${isEnabled}, isKioskPage=${isKioskPage}`,
  );
  if (!isEnabled || isKioskPage) {
    return null;
  }

  return (
    <SessionTimeout
      timeoutSeconds={inactivityPeriod}
      company={company}
      guestBookSlug={guestBookSlug}
      isVisitor={isVisitor}
    />
  );
};
